import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { GetLikedGoodsCategoriesResponse } from './types';

/**
 * - 찜한 상품 카테고리 필터 옵션
 * - iOS `LikedProductRouter.categories` (`/members/me/likes/goods/categories/`) 와 동일
 */
export const getLikedGoodsCategories = () => {
  return defaultHttpClient
    .request<GetLikedGoodsCategoriesResponse>({
      method: 'GET',
      url: '/api/v2/members/me/likes/goods/categories/',
    })
    .then(result => result.data);
};
